import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
import { popUp, commonData } from "@/mixins/index";
export default {
  mixins: [popUp, commonData],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        appid: "",
        host: "",
        sms_account: "",
        sign: "",
        template_id: "",
        sms_type: '',
        template_param: [],
        phone_numbers: "",
        tag: "",
        ak: "",
        sk: ""
      },
      rules: {
        appid: [{
          required: true,
          message: "请选择应用",
          trigger: "blur"
        }],
        host: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        sms_account: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        sign: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        template_id: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        // phone_numbers: [{ required: true, message: "请输入", trigger: "blur" }],
        // tag: [{ required: true, message: "请输入", trigger: "blur" }],
        ak: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        sk: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, list, key;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getcommonData(['appListAllData']);

              case 2:
                _this.copyPrimitive();

                if (row) {
                  data = _objectSpread({}, row); // data.template_param = JSON.parse(data.template_param)

                  data.template_param = data.template_param;
                  list = [];

                  for (key in data.template_param) {
                    list.push({
                      lable: key,
                      value: data.template_param[key]
                    });
                  }

                  _this.formData = _objectSpread(_objectSpread({}, data), {}, {
                    template_param: list
                  });
                }

                _this.copyData();

                _this.dialogFormVisible = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addContent: function addContent() {
      this.formData.template_param.push({
        lable: "",
        value: ""
      });
    },
    removeContent: function removeContent(item) {
      var index = this.formData.template_param.indexOf(item);

      if (index !== -1) {
        this.formData.template_param.splice(index, 1);
      }
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data, size, d, reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 14;
                    break;
                  }

                  if (!_this2.formData.id) {
                    _context2.next = 4;
                    break;
                  }

                  _context2.next = 4;
                  return _this2.secondConfirmation();

                case 4:
                  data = JSON.parse(JSON.stringify(_this2.formData));
                  size = new Set(data.template_param.map(function (i) {
                    return i.lable;
                  })).size;

                  if (!(data.template_param.length !== size)) {
                    _context2.next = 9;
                    break;
                  }

                  _this2.$message.error('参数键不能输入相同的值');

                  return _context2.abrupt("return");

                case 9:
                  d = {};
                  data.template_param.forEach(function (item, index) {
                    d[item.lable] = item.value;
                  });
                  data.template_param = JSON.stringify(d); // data.tpl = data.tpl.replaceAll(this.$imgUrl, '')

                  reqFn = _this2.formData.id ? 'appPhoneCodeConfigUpdate' : 'appPhoneCodeConfigAdd';

                  _this2.$api[reqFn](_objectSpread(_objectSpread({}, data), {}, {
                    isMustAppid: 1
                  })).then(function (res) {
                    if (res.status == 200) {
                      _this2.$message({
                        message: '操作成功',
                        type: 'success'
                      });

                      _this2.dialogFormVisible = false;

                      _this2.$emit('change');
                    }
                  });

                case 14:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};